export default (values, value) => {
  if (value.trim().length === 0) {
    return true;
  }

  return /^[-+]?(?:\d*[.])?\d+$/.test(value);
};
